import type { ModuleFile } from '../../core/modules.ts';

// Módulo «channels»: manifiesto. Las pantallas se cargan de forma perezosa.
export const manifests: ModuleFile['manifests'] = [
  {
    id: 'channels',
    title: 'Canales',
    path: 'canales',
    nav: { group: 'Canal', label: 'Canales', icon: '◉', order: 1 },
    load: () => import('./ChannelsPage.tsx').then((m) => ({ default: m.ChannelsPage })),
  },
];
